import { useState } from "react"
import PageLayout from "components/layout/PageLayout"
import PaginationBar from "components/widget/PaginationBar"
import { useGetAllWhistlesQuery, useUpdateWhistleMutation } from "./api/whistleApiSlice"
import WhistleCard from "./components/WhistleCard"
import WhistlesStats from "./components/WhistlesStats"
import { useTranslation } from "react-i18next"

const WhistleManage = () => {

    const [t] = useTranslation(["global", "whistle"])
    const [requestPage, setRequestPage] = useState(0)

    const {
        data: response,
        isFetching,
        isSuccess,
        isError,
        error,
        refetch
    } = useGetAllWhistlesQuery(requestPage)

    const [updateStatusRequest, updateStatusResult] = useUpdateWhistleMutation()

    const handleStatusUpdate = (guid, newStatus) => {
        updateStatusRequest({ guid, newStatus })
    }

    const handleUrgencyUpdate = (guid, isUrgent) => {
        console.log(`The whistler (${guid}) update URGENCY:${isUrgent}`);
        updateStatusRequest({ guid, isUrgent })
    }

    let content


    content =
        <div>
            <WhistlesStats />
            {
                isSuccess &&

                <div className={`card bg-black bg-opacity-10 mb-4`} id="absence-request">
                    <div className="card-header">
                        <i className="fa-solid fa-circle-exclamation"></i> {t("whistle:menu.warnings")}
                    </div>

                    <div className="card-body text-center p-4">
                        <div className="row text-start text-muted mb-4 px-4 ">
                            <div className="col-sm">
                                {t("whistle:property.status")}
                            </div>
                            <div className="col-sm-1">
                                {t("whistle:property.priority")}
                            </div>
                            <div className="col-sm-5">
                                {t("whistle:property.object")}
                            </div>
                            <div className="col-sm-3">
                                {t("whistle:property.reported_by")}
                            </div>
                            <div className="col-sm-1">
                                {t("global:property.submited")}
                            </div>
                        </div>

                        {response.content.map(whistle => (

                            <WhistleCard
                                key={whistle.guid}
                                whistle={whistle}
                                isManageable={true}
                                onStatusChange={handleStatusUpdate}
                                onUrgencyChange={handleUrgencyUpdate}
                            />
                        ))}

                        <PaginationBar
                            currentPage={requestPage + 1}
                            postsPerPage={response.pageable.pageSize}
                            totalPosts={response.totalElements}
                            paginate={(e) => {
                                console.log(e)
                                setRequestPage(e - 1)
                            }}
                        />
                    </div>
                </div>
            }
        </div>


    return <PageLayout
        pageTitle={t("whistle:menu.warnings")}
        isLoadingContent={isFetching}
        onPageRefresh={refetch}
        bodyContent={content}
    />
}

export default WhistleManage